<template>
  <div id="main">

  </div>
</template>

<script>

export default {
  data() {
    return {
    };
  },
  methods: {

  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>
